// extracted by mini-css-extract-plugin
module.exports = {"body":"LimboBotView_body__O3uTC","imageBanner":"LimboBotView_imageBanner__-IA8a","video":"LimboBotView_video__2Jxp_","panel":"LimboBotView_panel__1QW-u"};